// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 13) return "static/js/9634db725b77e5724804.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"95a89161a6dd5cb3cda3","136":"f9a0d622f95d488c82c7","137":"812a33b7326917e9e99c"}[chunkId] + ".chunk.js";
};